import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import './lib/setupAxiosAuth';
import './index.css';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import DashboardPage from './pages/DashboardPage';
import DocumentsPage from './pages/DocumentsPage';
import DocumentViewPage from './pages/DocumentViewPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import GoogleAuthCallbackPage from './pages/GoogleAuthCallbackPage';
import LoginPage from './pages/LoginPage';
import PdfViewerPage from './pages/PdfViewerPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

function App() {
  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/oauth/callback" element={<GoogleAuthCallbackPage />} />
            <Route path="/auth/google" element={<GoogleAuthCallbackPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/documents" element={<ProtectedRoute><DocumentsPage /></ProtectedRoute>} />
            <Route path="/document/:documentId" element={<ProtectedRoute><DocumentViewPage /></ProtectedRoute>} />
            <Route path="/pdf/:documentId" element={<ProtectedRoute><PdfViewerPage /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster richColors position="top-right" />
    </>
  );
}

export default App;
